import { useState } from "react";
import { FormControl, SelectChangeEvent } from "@mui/material";
import useTranslate from "../../../hooks/useTranslate";
import { createObjectWithCondition } from "../../../helpers";
import { ConditionTypeExtended } from "../../../constants/robotConfigLists";
import { colorSecondary } from "../../../constants/colors";
import { ConditionType } from "../../../types/ses/sesItemConfigTypes";
import { IFormAddingConditionProps } from "./FormAddingCondition.props";
import { Hint } from "@/HOC";
import { IconSelect } from "@/ui";
import { CONDITIONS_LIST, CONDITIONS_LIST_ICONS } from "./FormAddingCondition.const";

const FormAddingCondition = ({ addCondition, listOfSkipConditions }: IFormAddingConditionProps): JSX.Element => {
	const [conditionType, setConditionType] = useState<ConditionTypeExtended>("chooseType"); // тип условия

	const translate = useTranslate(); // hook для перевода текста

	// обработчик добавления условия
	const addConditionHandler = (e: SelectChangeEvent<ConditionTypeExtended | "yes" | "no">): void => {
		const data =
			e.target.value === "yes" || e.target.value === "no"
				? createObjectWithCondition("confirmation", e.target.value)
				: createObjectWithCondition(e.target.value as Exclude<ConditionType, "or">);

		addCondition(data); // добавление условия в store
		setConditionType("chooseType"); // сбрасываем поле
	};

	return (
		// форма добавления условия

		<div style={{ display: "flex", width: "100%" }}>
			{/* тип условия */}
			<FormControl margin="none" sx={{ minWidth: 22, m: "8px auto", '.MuiInputLabel-root[data-shrink="false"]': { top: -8 }, ".MuiSelect-select": { paddingBlock: 0 } }}>
				<Hint hint={translate("hint_BlockAnd")} position="top">
					<IconSelect<Exclude<ConditionTypeExtended, "or"> | "yes" | "no">
						value={conditionType as Exclude<ConditionTypeExtended, "or" | "chooseType"> | "yes" | "no"}
						onChange={addConditionHandler}
						iconList={CONDITIONS_LIST_ICONS}
						itemsList={CONDITIONS_LIST.filter((type) => !(listOfSkipConditions || []).includes(type.value))}
						mainIconColor={colorSecondary}
						mode={conditionType === "chooseType" ? "textOnInitial" : "fullIcon"}
						initialText={conditionType === "chooseType" ? `${translate("button_addCondition")}...` : ""}
					/>
				</Hint>
			</FormControl>
		</div>
	);
};

export default FormAddingCondition;
